import Vue from 'vue'
import App from './App.vue'

import axios from "axios";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false

// axios.defaults.baseURL = "http://47.243.170.250:8091/cgm_chat_api_web"
// axios.defaults.baseURL = "http://localhost:8091/cgm_chat_api_web"
axios.defaults.baseURL = "https://chat.cgmgroup.jp/cgm_chat_api_web"
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.axios = axios;

Vue.use(ElementUI);

new Vue({
  render: h => h(App),
}).$mount('#app')
